<template>
	<div class="page doc">
		<div class="nav">
			<el-menu @open="click" @close="click" :router="true" default-active="1"  active-text-color="#83ff31">
				<el-submenu index="introduce">
					<template slot="title">入门</template>
					<el-menu-item @click="view('overview')">概述</el-menu-item>
					<el-menu-item @click="view('ide')">IDE</el-menu-item>
					<el-menu-item @click="view('grpc')">gRPC</el-menu-item>
					<el-menu-item @click="view('environment')">环境准备</el-menu-item>
				</el-submenu>
				<el-submenu index="language">
					<template slot="title">快速开始</template>
					<el-menu-item @click="view('python')">Python</el-menu-item>
					<el-menu-item @click="view('cpp')">C++</el-menu-item>
					<el-menu-item @click="view('node')">Node</el-menu-item>
				</el-submenu>
				<el-submenu index="demo">
					<template slot="title">例子</template>
					<el-menu-item @click="view('pythondemo')">RPC接口测试</el-menu-item>
					<el-menu-item @click="view('grip')">RPC配合夹爪抓物品</el-menu-item>
					<el-menu-item @click="view('webot')">Webot通过RPC获取数据</el-menu-item>
				</el-submenu>
				<el-submenu index="resource">
					<template slot="title">资源</template>
					<el-menu-item @click="view('proto')">PROTO文件</el-menu-item>
				</el-submenu>
				<el-submenu index="api">
					<template slot="title">API</template>
				</el-submenu>
				<el-submenu index="release_note">
					<template slot="title">更新记录</template>
				</el-submenu>
			</el-menu>
		</div>

		<div class="markdown-body">
			<component :is="doc_name"></component>
		</div>
	</div>
</template>

<script>
	import {
		components
	} from "../utils/doc"
	export default {
		mounted() {
			this.doc_name = this.$route.params.doc_name
		},
		components: components,
		data() {
			return {
				doc_name: ""
			}
		},
		methods: {
			//查看文档
			view(doc_name) {
				// 这里改变路由并没有用，实际内容的切换时通过切换组件完成，只是为了url对应
				var new_path = "/doc/" + doc_name
				if (this.$route.path != new_path) {
					this.$router.push(new_path)
				}
				this.doc_name = doc_name
				return
			},
			// 选择菜单
			click(doc,index_path) {
				this.view(doc)
			}
		}
	}
</script>

<style lang="scss" scoped>
	$nav-bar-width: 200px;

	.page {
		display: flex;
		background: white;

		.nav {
			margin-top: $nav-bar-height;
			height: 100%;
			width: $nav-bar-width;
		}

		.markdown-body {
			display: flex;
			flex-grow: 1;
			margin-left: $nav-bar-width;
			margin-top: $nav-bar-height;
			padding: 20px;
			box-sizing: border-box;
			// background: white;
		}
	}
</style>

<style lang="scss">
	.doc {

		.el-menu {
			height: 100%;
			border-right: 1px solid white;
			background-color: white!important;


			.el-menu-item,
			.el-submenu__title {
				text-align: center;
				border-right: 1px solid white;
			}

			.el-submenu__title {
				font-size: 18px;
				font-weight: 900;
				text-decoration: underline;
			}
		}

	}
</style>
